import React from "react"
import PropTypes from "prop-types"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import quote from "../../assets/images/quote-left.png"

import remarkReactComponents from "../../helpers/remarkReactComponents"
import Image from "../image"

const Quote = ({ blok }) => (
  <div className="quote">
    <div className="quote__icon">
      <Image
        blok={{ image: quote, alt: blok.author_name, title: blok.author_name }}
        className="icon icon--sm"
      />
    </div>
    <div className="quote__content">
      <blockquote className="quote__quote">
        {
          unified()
            .use(remarkParse)
            .use(remarkRehype)
            .use(rehypeReact, {
              createElement: React.createElement,
              components: remarkReactComponents,
              Fragment: React.Fragment
            })
            .processSync(blok.quote).result
        }
      </blockquote>
      <div className="quote__author">
        <p className="quote__author-name">{blok.author_name}</p>
        <p className="quote__author-from">{blok.author_from}</p>
      </div>
    </div>
  </div>
)

Quote.propTypes = {
  blok: PropTypes.shape({
    quote: PropTypes.string,
    author_name: PropTypes.string,
    author_from: PropTypes.string,
  }).isRequired,
}

export default Quote
